var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',{staticStyle:{"background":"#f8fbff!important"}},[_vm._v(">\n    "),_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }